import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import { injectStripe } from "react-stripe-elements";
import PersonStore from "../../stores/PersonStore";
import api from "../../utils/api";
import { RaisedButton } from "material-ui";

@connectToStores
class PaymentMethodEntryV2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      bootstrapData: null,
      isConfirmingPaymentMethod: false,
      errorMessage: null
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool
    };
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  getStyles() {
    return {
      submitButton: {
        marginTop: "10px"
      },
      actions: {
        marginTop: "1em"
      },
      error: {
        color: "#FF4136",
        margin: "-0.5em 0 0.5em"
      }
    };
  }

  isSubmitButtonDisabled(oldState) {
    const { ready, isConfirmingPaymentMethod } = oldState || this.state;

    return isConfirmingPaymentMethod || !ready;
  }

  componentDidMount() {
    this.stripe = this.props.stripe;
    this.setupElements();
    if (this.props.getRef) this.props.getRef(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const submitButtonDisabled = this.isSubmitButtonDisabled();
    if (
      this.props.setDisabledState &&
      this.isSubmitButtonDisabled(prevState) !== submitButtonDisabled
    ) {
      this.props.setDisabledState(submitButtonDisabled);
    }
  }

  apiRequest(request) {
    return new Promise((resolve, reject) =>
      api.request(request, (err, response) => {
        if (err) return reject(err);

        return resolve(response);
      })
    );
  }

  async setupElements() {
    const bootstrapData = await this.apiRequest({
      method: "POST",
      endpoint: "people/self/setup_payment",
      json: {
        token: this.props.token
      }
    });

    this.setState({ bootstrapData });

    this.elements = this.stripe.elements({
      clientSecret: bootstrapData.client_secret
    });
    this.paymentElement = this.elements.create("payment", {
      layout: {
        type: "tabs",
        defaultCollapsed: false
      },
      business: {
        name: "Eventive"
      },
      fields: {
        billingDetails: {
          name: "never",
          email: "never"
        }
      },
      terms: {
        card: "never"
      }
    });
    this.paymentElement.on("ready", () => {
      this.setState({ ready: true });
    });
    this.paymentElement.mount(this.elementDiv);
  }

  async onFormSubmit(event) {
    if (event) event.preventDefault();

    this.setState({
      isConfirmingPaymentMethod: true,
      errorMessage: null
    });

    const { stripe, elements } = this;

    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.append("_complete_checkout", "1");

    let result;
    try {
      result = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: returnUrl.href,
          payment_method_data: {
            billing_details: {
              name: this.props.details.name || this.props.details.email,
              email: this.props.details.email
            }
          }
        },
        redirect: "if_required"
      });
    } catch (e) {
      console.error(e);
      result = { error: e };
    }

    if (result.error) {
      // Show error to your customer (e.g., payment details incomplete)
      this.setState({
        isConfirmingPaymentMethod: false,
        errorMessage: result.error.message
      });
    } else if (result.setupIntent) {
      // Redirect was not required, so complete the checkout inline.
      this.props.onConfirm(result.setupIntent);
      this.setState({
        isConfirmingPaymentMethod: false,
        errorMessage: null
      });
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }

    return result;
  }

  render() {
    var styles = this.getStyles();

    return (
      <form onSubmit={this.onFormSubmit}>
        <div
          ref={r => {
            this.elementDiv = r;
          }}
        />

        <div style={styles.actions}>
          {this.state.errorMessage ||
          this.props.paymentInfoUpdateErrorMessage ? (
            <div style={styles.error}>
              {this.state.errorMessage ||
                this.props.paymentInfoUpdateErrorMessage}
            </div>
          ) : null}

          {this.props.onCancel ? (
            <RaisedButton
              label="Cancel"
              primary={false}
              style={
                this.context.isLarge ? { marginRight: 7 } : { marginBottom: 10 }
              }
              onClick={this.props.onCancel}
            />
          ) : null}

          {this.props.submitButtonDisabled ? null : (
            <RaisedButton
              label={
                this.props.submitButtonLabel ||
                (this.state.isConfirmingPaymentMethod ||
                this.props.paymentInfoUpdateInProgress
                  ? "Submitting payment information..."
                  : "Submit payment information")
              }
              primary={true}
              disabled={
                this.state.isConfirmingPaymentMethod ||
                this.props.paymentInfoUpdateInProgress ||
                !this.state.ready
              }
              style={styles.submitButton}
              type="submit"
            ></RaisedButton>
          )}
        </div>
      </form>
    );
  }
}

export default injectStripe(PaymentMethodEntryV2);



// WEBPACK FOOTER //
// ./src/app/components/partials/payment-method-entry-v2.jsx